/**
 * {常量名、函数名}
 */
import Vue from "vue";
import http from "./http";
import axios from "axios";
import md5 from "js-md5";
import Router from "vue-router";
/**
 * 接口封装类
 */
/**
 * 公共调用方法
 * @param
 * @returns {Promise<unknown>}
 */

/**
 * 类目
 * @param type
 */

const getCategoryList = function (type) {
  return new Promise((resolve, reject) => {
    fetch("/dataJson/categoryList.json")
      .then((response) => response.json())
      .then((data) => {
        const list = JSON.parse(JSON.stringify(data));
        resolve({
          result: { categoryList: list },
          resultCode: 10000,
        });
      });
  });
};
/**
 * 成果列表
 * @param id
 */

const getResultList = function (id) {
  return new Promise((resolve, reject) => {
    fetch("/dataJson/categoryList.json")
      .then((response) => response.json())
      .then((data) => {
        const allData = JSON.parse(JSON.stringify(data));
        const info = allData.find((d) => d.categoryId == id);
        console.log(allData, id, info);
        if (info) {
          resolve({
            result: { achvItemList: info.achvItemList },
            resultCode: 10000,
          });
        } else {
          reject({
            resultCode: 10001,
          });
        }
      });
  });
};

/**
 * 成果列表

 */

const getIndexInfo = function () {
  return new Promise((resolve, reject) => {
    fetch("/dataJson/partnerList.json")
      .then((response) => response.json())
      .then((data) => {
        const allData = JSON.parse(JSON.stringify(data));
        resolve(allData);
      });
  });
};
/**
 *数据集列表
 * @param keywords
 * @param pageNo
 * @param pageSize
 * @param type
 * @param sort
 */

const getDatasetList = function (keywords, pageNo, pageSize, type, sort) {
  return new Promise((resolve) => {
    fetch("/dataJson/datasetList.json")
      .then((response) => response.json())
      .then((data) => {
        const allData = JSON.parse(JSON.stringify(data));
        let res = {
          page: {},
          datasetList: [],
        };
        res.page.current = pageNo;
        res.page.pages = pageNo;
        res.page.total = allData.length;
        res.datasetList = allData.slice(
          pageSize * (pageNo - 1),
          pageSize * pageNo
        );
        resolve({
          resultCode: 10000,
          result: res,
        });
      });
  });
};
/**
 * 数据集详情
 * @param id

 */

const getDatasetInfo = function (id) {
  //   const opts = {
  //     url: "/starry-graph-web/api/user/dataset/info",
  //     params: {
  //       id,
  //     },
  //   };
  return new Promise((resolve, reject) => {
    fetch("/dataJson/datasetList.json")
      .then((response) => response.json())
      .then((data) => {
        const allData = JSON.parse(JSON.stringify(data));
        const info = allData.find((d) => d.datasetId == id);
        if (info) {
          resolve({
            result: { dataset: info },
            resultCode: 10000,
          });
        } else {
          reject({
            resultCode: 10001,
          });
        }
      });
  });
};

/**
 *演示列表

 * @param pageNo
 * @param pageSize

 */

const getDemonstrationList = function (pageNo, pageSize) {
  return new Promise((resolve, reject) => {
    fetch("/dataJson/demonstration.json")
      .then((response) => response.json())
      .then((data) => {
        const allData = JSON.parse(JSON.stringify(data));
        let res = {
          page: {},
          demonstrationList: [],
        };
        res.page.current = pageNo;
        res.page.pages = pageNo;
        res.page.total = allData.length;
        res.demonstrationList = allData.slice(
          pageSize * (pageNo - 1),
          pageSize * pageNo
        );
        resolve({
          resultCode: 10000,
          result: res,
        });
      });
  });
};
/**
 *演示详情

 * @param id
 */

const getDemonstrationInfo = function (id) {
  return new Promise((resolve, reject) => {
    fetch("/dataJson/demonstration.json")
      .then((response) => response.json())
      .then((data) => {
        const allData = JSON.parse(JSON.stringify(data));
        let res = {};
        const demo = allData.find((item) => item.demonstrationId == id);
        if (demo) {
          resolve({
            resultCode: 10000,
            result: {
              demonstration: demo,
            },
          });
        } else {
          reject({
            resultCode: 10001,
          });
        }
      });
  });
};

/**
 *训练版本列表

 * @param id
 * @param pageNo
 * @param pageSize
 */

const getInferencePublicRecordList = function (id, pageNo, pageSize) {
  return new Promise((resolve, reject) => {
    fetch("/dataJson/demonstration.json")
      .then((response) => response.json())
      .then((data) => {
        const allData = JSON.parse(JSON.stringify(data));
        let res = {};
        const demo = allData.find((item) => item.projectId === id);
        if (demo) {
          resolve({
            resultCode: 10000,
            result: {
              inferenceRecordList: demo.inferenceRecordList,
            },
          });
        } else {
          reject({
            resultCode: 10001,
          });
        }
      });
  });
};
/**
 *演示预测数据

 * @param visType
 * @param inferenceRecordId
 * @param key
 */

const geprdeictList = function (visType, inferenceRecordId, key, key1) {
  return new Promise((resolve, reject) => {
    if (visType == 1) {
      fetch("/dataJson/demonstrationData1.json")
        .then((response) => response.json())
        .then((data) => {
          const allData = JSON.parse(JSON.stringify(data));
          resolve(allData);
        });
    } else {
      fetch("/dataJson/vis_prediction.json")
        .then((response) => response.json())
        .then((data) => {
          const yearData = data[key];
          if (yearData) {
            const unvData = yearData.filter((y) => y.indexOf(key1) > -1);
            if (unvData && unvData.length) {
              resolve({
                resultCode: 10000,
                result: {
                  visData: unvData,
                },
              });
            } else {
              reject({
                resultCode: 10001,
              });
            }
          } else {
            reject({
              resultCode: 10001,
            });
          }
        });
    }
  });
};
/**
 *获取采样数据

 * @param inferenceRecordId
 */

const geSampleList = function (inferenceRecordId) {
  return new Promise((resolve, reject) => {
    fetch("/dataJson/demonstration.json")
      .then((response) => response.json())
      .then((data) => {
        const allData = JSON.parse(JSON.stringify(data));
        const demo = allData.find(
          (item) => item.inferenceRecordId === inferenceRecordId
        );
        if (demo) {
          resolve({
            resultCode: 10000,
            result: {
              sample: demo.sample,
            },
          });
        } else {
          reject({
            resultCode: 10001,
          });
        }
      });
  });
};

export default function (Vue) {
  //添加全局API
  Vue.prototype.$api = {
    getCategoryList,
    getResultList,
    getIndexInfo,
    getDatasetList,
    getDatasetInfo,
    getDemonstrationList,
    getDemonstrationInfo,
    getInferencePublicRecordList,
    geprdeictList,
    geSampleList,
  };

}
